import { handleActions } from "redux-actions";
import {
    BRAND_AVAILABLE_SHIPPING_CARRIERS_COMPLETE,
    BRAND_AVAILABLE_SHIPPING_CARRIERS_REQUEST,
} from "constants/action-types";

interface IState {
    error?: boolean;
    isFetching: boolean;
    results: string[];
}

const initialState: IState = {
    error: undefined,
    isFetching: false,
    results: [],
};

export const shippingCarriers = handleActions(
    {
        [BRAND_AVAILABLE_SHIPPING_CARRIERS_REQUEST]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [BRAND_AVAILABLE_SHIPPING_CARRIERS_COMPLETE]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...state,
                    error: true,
                    isFetching: false,
                };
            }

            return {
                ...state,
                error,
                isFetching: false,
                results: payload as string[],
            };
        },
    },
    initialState
);
